export class UploadFileInfo {
  id: number = 0;
  lastUpdateTime?: Date = new Date();
  numberOfEntries: number = 0;
  numberOfErrors: number = 0;
  uploadFileStatus: string = '';
  uploadFileType: UploadFileType = UploadFileType.CimPowerTransformer;
  name?: string;
  email?: string;
  role?: string;
}

export enum UploadFileType {
  Customers,
Poles,
Buildings,
Dts,
Meters,
Surveys,
DtsCrud,
BulkReassign,
BulkUserCreation,
MetersStock,
Regularization,
BillingAccount,
CustomersConvert,
CustomersUpdate,
FlagMetersForMeterValidation,
ReassignDts,
Substations,
CimPowerTransformer,
ACLine,
NewConnection,
MeterConfiguration,
BulkVendorAssignment,
BulkConfirmPayment,
UploadCustomerUpdate,
UpdateFeederBands,
InstallationBulkAssignment,
BulkVendorReassignment,
BulkOrgAssignment,
BulkFeederReassignment,
BulkRoleReassignment,
BulkSubstationUpdate,
BulkAcLineUpdate
}
